import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { toastr } from 'react-redux-toastr'
import Toggle from 'react-toggle'

import { CustomButtonToggle } from '../../../component/DropdownComponents'
import CustomButton from '../../../component/CustomButton'
import NotificationsModal from '../../../component/smart/modals/NotificationsModal'
import IconTooltip from '../../../component/dump/menuComponents/IconTooltip'
import { updateUserNotifications } from '../../../../../shared/api/action/AccountActions'
import { updateFleetUser } from '../../../../../shared/api/action/ClientActions'
import { bellIcon } from '../../../component/helpers/iconHelpers'

import 'react-toggle/style.css'

const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

const DashboardNotificationsBell = (props) => {
    const { panelTitle, subcategories, notifications, userEmail, userRole, getNotifications, scrollable, twoColumns } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountNotificationsContainer' });

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);

    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedName, setSelectedName] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [selectedNotification, setSelectedNotification] = useState(null);

    const toggleLoaderModal = (show) => dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
    const updateUser = (updatedUser) => dispatch({ type: 'GET_USER_SUCCESS', payload: updatedUser });

    const auxInputEmail = notifications?.inputsensor1 && (notifications.inputsensor1.email || notifications.inputsensor2.email || notifications.inputsensor3.email || notifications.inputsensor4.email);
    const auxInputSms = notifications?.inputsensor1 && (notifications.inputsensor1.sms || notifications.inputsensor2.sms || notifications.inputsensor3.sms || notifications.inputsensor4.sms);

    const openNotification = (name, title) => {
        setSelectedName(name);
        setSelectedTitle(title);
        setSelectedNotification(name !== 'input_sensor'
            ? (notifications?.[name] || {})
            : [notifications?.inputsensor1, notifications?.inputsensor2, notifications?.inputsensor3, notifications?.inputsensor4]);
    };

    const handleSave = (data) => {
        const { phone_number, sms, voice } = data;
        const reqArray = [updateUserNotifications(userEmail, data)];
        if ((sms || voice) && phone_number && phone_number !== user.phone_number) {
            reqArray.push(updateFleetUser({
                user_email: user.email,
                user_role: user.roles[0],
                data: { phone_number },
            }));
        }

        toggleLoaderModal(true);
        Promise.all(reqArray)
            .then((res) => {
                toastr.success(t('updatedNotificationSettings'));
                toggleLoaderModal(false);
                if (res[1] && res[1].data) {
                    updateUser(res[1].data.response.user);
                }
                setSelectedName(null);
                getNotifications();
            })
            .catch(() => {
                toastr.error(t('issueUpdatingNotificationSettings'));
                toggleLoaderModal(false);
            });
    };

    const notificationGroups = subcategories.map(({ title: subTitle, notifsArr }) => (
        <div key={subTitle || 'default'} className="dashboard-notif-modal__group">
            {subTitle && <h6 className="category-subtitle dashboard-notif-modal__group-title">{capitalize(t(subTitle.replace(/\s/g, '_')))}</h6>}
            <div className={twoColumns ? 'two-column-grid dashboard-notif-modal__rows' : 'dashboard-notif-modal__rows'}>
                {notifsArr
                    .filter((notif) => !notif.access || notif.access.includes(userRole))
                    .map((notif) => {
                        const value = notif.name === 'input_sensor'
                            ? { email: auxInputEmail, sms: auxInputSms }
                            : (notifications?.[notif.name] || {});
                        return (
                            <div key={notif.name} className="dashboard-notif-row">
                                <div className="dashboard-notif-row__label">
                                    <span className="dashboard-notif-row__title">{capitalize(t(notif.title.replace(/\s/g, '_')))}</span>
                                    <IconTooltip
                                        id={`dashboard-notif-tooltip-${notif.name}`}
                                        description={t(notif.title.replace(/\s/g, '_') + '_description')}
                                        placement="top"
                                    />
                                </div>
                                <Toggle
                                    name={notif.name}
                                    checked={!!(value.email || value.sms || value.voice)}
                                    onChange={() => openNotification(notif.name, notif.title)}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    ));

    return (
        <>
            {twoColumns ? (
                <>
                    <CustomButton prefix="dashboard-notif-bell__btn" onClick={() => setMenuOpen(true)}>
                        {bellIcon}
                    </CustomButton>
                    {menuOpen && (
                        <Modal show centered onHide={() => setMenuOpen(false)} className="dashboard-notif-modal">
                            <Modal.Header closeButton>
                                <Modal.Title>{capitalize(panelTitle)}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className={scrollable ? 'dashboard-notif-modal__body--scrollable' : ''}>
                                {notificationGroups}
                            </Modal.Body>
                        </Modal>
                    )}
                </>
            ) : (
                <Dropdown align="end" className="dashboard-notif-bell" show={menuOpen} onToggle={setMenuOpen}>
                    <Dropdown.Toggle as={CustomButtonToggle} wrapperClassName="no-caret dashboard-notif-bell__btn">
                        {bellIcon}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={`dashboard-notif-popover${scrollable ? ' dashboard-notif-popover--scrollable' : ''}`}>
                        <h5 className="dashboard-notif-modal__title category-title">{capitalize(panelTitle)}</h5>
                        <div className="dashboard-notif-popover__list">
                            {notificationGroups}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            )}
            {selectedName && (
                <NotificationsModal
                    notification={selectedNotification}
                    selectedName={selectedName}
                    selectedTitle={selectedTitle}
                    hideNotificationsModal={() => setSelectedName(null)}
                    updateNotifications={handleSave}
                    userEmail={userEmail}
                    readOnly={false}
                />
            )}
        </>
    );
};

export default DashboardNotificationsBell;
